import {
	analyzerLinks, chartFullscreen, closeEvolutionModal, detailsToggle, evolutionModal, openCellEvolution, priceCell, priceCellBox,
	pricesChart, priceTable, reportSelector,
} from 'Pages/AnalyzersV2/@tour/targets'

const ES = navigator.language?.startsWith('es')

export const TOUR_STEPS = [
	// Intro
	{
		type: 'intro',
		icon: 'star',
		title: ES ? 'Bienvenido al Analizador de Rating' : 'Welcome to the Rating Analyzer',
		description: ES
			? 'El Analizador de Rating evalúa las puntuaciones y valoraciones de clientes en distintos proveedores y plataformas de reseñas. Entiende cómo se compara la calidad de tu servicio frente a los competidores.'
			: 'The Rating Analyzer evaluates customer review scores and ratings across different providers and review platforms. Understand how your service quality compares to competitors.',
	},
	// Report Selector
	{
		type: 'field',
		skipIf: () => !reportSelector(),
		findTarget: reportSelector,
		icon: 'file-lines',
		title: ES ? 'Selector de Informe' : 'Report Selector',
		description: ES
			? 'Selecciona una ejecución de informe de este desplegable para cargar los datos del análisis de rating. Los informes de rating agregan puntuaciones de reseñas de múltiples fuentes.'
			: 'Select a report execution from this dropdown to load the rating analysis data. Rating reports aggregate review scores from multiple sources.',
	},
	// Analyzer shortcuts (only with a report selected)
	{
		type: 'field',
		skipIf: () => !analyzerLinks(),
		findTarget: analyzerLinks,
		icon: 'arrow-up-right-from-square',
		title: ES ? 'Otros Analizadores' : 'Other Analyzers',
		description: ES
			? 'Estos botones abren el mismo informe en otro analizador (LOR, DOR, Sitio Directo o Brokers) en una pestaña nueva. Solo aparecen los analizadores disponibles para este informe.'
			: 'These buttons open the same report in another analyzer (LOR, DOR, Direct Site or Brokers) in a new tab. Only the analyzers available for this report appear.',
	},
	// Rating Table
	{
		type: 'field',
		findTarget: priceTable,
		icon: 'table-cells',
		title: ES ? 'Tabla de Ratings' : 'Rating Table',
		description: ES
			? 'La tabla comparativa principal que muestra las puntuaciones de rating por proveedor (filas) y sitio (columnas). Las celdas se colorean como indica la leyenda bajo la tabla.'
			: 'The main comparison table showing rating scores by provider (rows) and site (columns). Cells are colored as the legend under the table reads.',
		example: ES
			? 'Verde = «Cheapest Rating in column» | Rojo = «Most Expensive Rating in column»'
			: 'Green = "Cheapest Rating in column" | Red = "Most Expensive Rating in column"',
	},
	// Toggle Details
	{
		type: 'field',
		findTarget: detailsToggle,
		icon: 'toggle-on',
		title: ES ? 'Mostrar/Ocultar Detalles' : 'Toggle Details',
		description: ES
			? 'Con «Show details» cada celda muestra, además de la puntuación, su variación y la puntuación anterior. Con «Hide details» solo queda la puntuación y la tabla es más compacta.'
			: 'With "Show details" each cell shows, besides the score, its change and the previous score. With "Hide details" only the score is left and the table is more compact.',
	},
	// Rating Cell → opens the evolution chart directly (no popover in Rating)
	{
		type: 'field',
		findTarget: priceCellBox,
		action: openCellEvolution,
		waitFor: () => !!evolutionModal() || !priceCell(),
		icon: 'star',
		title: ES ? 'Clic en Celda → Evolución Directa' : 'Cell Click → Direct Evolution',
		description: ES
			? 'A diferencia de otros analizadores, en Rating no hay popover intermedio: hacer clic en cualquier celda abre directamente el gráfico de evolución histórica de esa puntuación. Más rápido y directo.'
			: 'Unlike other analyzers, Rating has no intermediate popover: clicking any cell directly opens the historical evolution chart for that score. Faster and more direct.',
	},
	// Evolution Chart (modal open) — Next closes it
	{
		id: 'evolution-chart',
		type: 'field',
		findTarget: evolutionModal,
		action: closeEvolutionModal,
		cleanup: closeEvolutionModal,
		icon: 'chart-line',
		title: ES ? 'Gráfico de Evolución de Rating' : 'Rating Evolution Chart',
		description: ES
			? 'Vista completa de la evolución de las puntuaciones a lo largo del tiempo. Muestra las tendencias de valoración para todos los proveedores seleccionados, con una línea por proveedor.'
			: 'Full view of rating score evolution over time. Shows rating trends for all selected providers, with one line per provider.',
	},
	// Rating Chart (Sites filter + Price values / Variation (%) toggle)
	{
		type: 'field',
		findTarget: pricesChart,
		icon: 'chart-bar',
		title: ES ? 'Gráfico de Ratings' : 'Rating Chart',
		description: ES
			? 'Comparación visual de ratings entre proveedores. El filtro «Sites» muestra las puntuaciones de un sitio concreto. Alterna entre valores absolutos y variación porcentual.'
			: 'Visual comparison of ratings across providers. The "Sites" filter shows the scores of one specific site. Toggle between absolute values and percentage variation.',
		example: ES ? 'Price values = Puntuación | Variation (%) = % de diferencia' : 'Price values = Score | Variation (%) = % difference',
	},
	// Fullscreen Chart
	{
		type: 'field',
		findTarget: chartFullscreen,
		icon: 'expand',
		title: ES ? 'Gráfico en Pantalla Completa' : 'Fullscreen Chart',
		description: ES
			? 'Amplía el gráfico a pantalla completa para una vista más clara. Especialmente útil al comparar muchos proveedores o cuando quieres analizar la tendencia de rating con más detalle.'
			: 'Expand the chart to full screen for a clearer view. Especially useful when comparing many providers or when you want to analyze the rating trend in more detail.',
	},
	// Outro
	{
		type: 'outro',
		icon: 'star',
		title: ES ? '¡Todo Listo!' : "You're All Set!",
		description: ES
			? 'Haz clic en cualquier celda de rating para ver su evolución histórica directamente. Usa el filtro «Sites» del gráfico para comparar puntuaciones por sitio.'
			: 'Click on any rating cell to directly view its historical evolution. Use the "Sites" filter on the chart to compare scores by site.',
	},
]
